import Backbone from 'backbone';
import Model from './model';

export default Backbone.Collection.extend({
	model: Model,

	url: function() {
		return document.URL;
	}
});

